import { Injectable, isDevMode } from '@angular/core'
import { RequestOptions } from '@angular/http';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { UrlsResources } from "../urls-resources";
import { ElectronicPaymentModel } from "./electronic-payment.model";
import { AccountaymentModel } from './account-payment.model';
import { HandleError } from '../handle-error';
import * as moment from "moment";

@Injectable()
export class PaymentService {

  private options = {
    headers: new HttpHeaders().set('Content-Type', 'application/json; charset=UTF-8')
  };

  constructor(private http: HttpClient,
    private handleError: HandleError,
    private urlsResources: UrlsResources) {
  }

  /**
   * ELECTRONIC ACCOUNT
   */
  doElectronicPayout(electronicPayout: ElectronicPaymentModel){
    const httpOptions = {
      withCredentials: true
    };
    return this.http.post(this.urlsResources.doElectronicPayout(), electronicPayout, httpOptions)
      .map(response => {
        return response;
      }).catch(error => {
        return this.handleError.handleErrorAsObservable(error)
      });
  }

  doPayout2Account(payout: AccountaymentModel): Observable<any> {
    if (isDevMode()) {
      console.log(' [ PaginatorService] :: [getDataToPaginator] :::::');
    }

    const httpOptions = {
      withCredentials: true
    };
    let options = new RequestOptions({ withCredentials: true });
    this.options.headers.set('withCredentials','true');

    return this.http.post(
      this.urlsResources.doPayout2Account(),
      payout,httpOptions)
      //{ headers: this.headers })
      .map(response => {
        //let res = response.json();
        return response;

      }).catch(error => {
        return this.handleError.handleErrorAsObservable(error)//Observable.throw(error)
      });
  }

  getPaymentDashboard(rangeDates: Date[]): Observable<any> {

    let methodParams: HttpParams =
      new HttpParams()
        .set('fechaInicial', moment(rangeDates[0]).format("YYYY-MM-DD"))
        .set('fechaFinal', moment(rangeDates[1]).format("YYYY-MM-DD"));

    const httpOptions = {
      params: methodParams,
      withCredentials: true
    };

    return this.http.get(this.urlsResources.getPaymentsDashboard(), httpOptions)
      .map(response => {
        return response;
      }).catch(error => {
        return this.handleError.handleErrorAsObservable(error)
      });

  }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/payments/payments.service.ts